import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
interface DataChartProps {
  smartscan: number;
  photos: number;
}

export const ChartPie = ({ data }: Routes) => {
  const { getSizesComponent, componentProperty } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [widthChart, setWidthChart] = useState(300);
  const [total, setTotal] = useState<number>(0);

  const dataChart: DataChartProps = {
    smartscan: data.smartscan,
    photos: data.photos,
  };

  useEffect(() => {
    setTotal(dataChart.smartscan + dataChart.photos);
  }, [data]);

  const getPositionLegend = (width: number, height: number): 'right' | 'bottom' => {
    if (width < 250 || height / width > 1.5) {
      return "bottom"
    } else {
      return "right";
    }
  };

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "pie",
    },
    stroke: {
      colors: undefined,
    },
    labels: ["SmartScan", "Foto normal"],
    colors: ["#FFC125", "#01b8aa"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend:{
      position: getPositionLegend(widthChart, heightChart)
    },
  };

  const series = [dataChart.smartscan, dataChart.photos];

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-deliveries" });
    if(sizes.width < 250){
      setHeightChart(sizes.height-30);
    }else{
      setHeightChart(sizes.height-(0.20*sizes.height));
    }
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100 component-height">
      <HeaderComponent
        title={`Foto/SmartScan: ${total} entregas realizadas`}
        clickable={componentProperty({
          id: "chartDeliveries",
          property: "redirect",
        })}
        id="chart-deliveries"
      />
      <div id="chart" className="component-content">
        <Chart
          type="pie"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
